module.exports = __webpack_public_path__ + "img/logo-indocyber.9d273c49.png";